<template>
  <div id="tos" class="has-text-left">
    EASY UPLOADER（以下、当サイト)は、本利用規約に同意される方のみ利用できる。<br>
    尚、本利用規約は当サイトへアクセスし、サービスを利用した時点で有効とする。同意しない場合は利用できない。<br>
    <br>
    A.利用規約を要約したもの<br>
    <br>
    1.日本国憲法及び法律を守る。<br>
    2.自己責任で利用し管理者は一切の責任を負わない。<br>
    3.常識の範囲内で利用する。<br>
    <br>
    B.サービスの利用に関して<br>
    <br>
    1.当サイトのすべては自己責任で利用するものとし、生じた不利益について管理者は一切の責任を負わない。<br>
    2.当サイトを利用する際に生じる全ての権利を管理者が持つものとする。（アップロードされたファイルに関する権利を除きます。）<br>
    3.利用規約は利用者に告知することなく変更できる。変更内容は改定と同時に適用される。<br>
    4.日本の法律が適用される。<br>
    5.当サイトのすべては予告無しに提供を中止、停止する可能性がある。<br>
    6.何らかのトラブルなどにより、利用規約を理解する事ができない場合はサービスを利用しない。<br>
    <br>
    C.アップロードされたファイルに関して<br>
    <br>
    1.アップロードされたファイルに関するすべてはアップロードした利用者が責任を持ち、管理者は一切の責任を負わない。<br>
    2.アップロードされたファイルに関する第三者との問題はアップロードした利用者が責任を持って解決する。<br>
    3.アップロードされたファイルに関して何らかの問題がある場合、管理者は処置する事ができるが、その義務はない。<br>
    <br>
    D.禁止行為<br>
    <br>
    1.著作権など、他者の権利を侵害する行為。<br>
    2.日本の法律に違反する行為。<br>
    3.故意にサーバーに負担をかける行為。<br>
    4.運営に支障を来す恐れのある行為。<br>
    5.過多の連続アップロード。<br>
    <br>
    E.情報の開示/処置<br>
    <br>
    1.当サイトの利用規約に違反、開示しなければならないと管理者が判断した場合は利用者の接続情報などを開示し、処置する事ができる。これは利用者が拒否することはできない。<br>
    2.法令などにより情報の開示を求められた場合、管理者は利用者の接続情報などの情報を第三者に開示する事ができる。これは利用者が拒否することはできない。<br>
    <br>
    F.管理者について/権限<br>
    <br>
    1.当サイトのすべてを管理者は、利用者・第三者・要望に関係無く処置、管理（削除など）することができる。また、その義務はない。<br>
    <br>
    2018年 5月 13日 施行
  </div>
</template>

<script>
export default {
  name: 'Tos'
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Tos.vue